import React from 'react';
import { withStyles, Fab } from '@material-ui/core';
import PropTypes from 'prop-types';
import CreateIcon from '@material-ui/icons/Create';
import styles from '../styles';
import {
  Card, CardBody, CardHeader, CardIcon,
} from '~/components/Card';
import { generateDailyPassword, getPasswordExpirationTime } from '~/utils/hash';

const EquipmentStatusPasswordModal = ({
  classes,
  equipId,
  translate,
  handleClose,
}) => (
  <div>
    <Card>
      <CardHeader icon>
        <CardIcon color="warning">
          <CreateIcon />
        </CardIcon>
      </CardHeader>
      <CardBody>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <p style={{ fontSize: '1.5rem' }}>
              {translate('common:UnlockPassword')}
              :
              {' '}
              <b>{generateDailyPassword(equipId)}</b>
            </p>
          </div>
          <div>
            <span className="warning">
              {translate('common:UnlockPasswordValidUntil')}
              :
              {' '}
              {getPasswordExpirationTime()}
            </span>
          </div>

          <Fab
            variant="extended"
            size="medium"
            color="secondary"
            onClick={() => {
              handleClose();
            }}
            className={classes.saveButton}
          >
            {translate('common:Close')}
          </Fab>
        </div>
      </CardBody>
    </Card>
  </div>
);

EquipmentStatusPasswordModal.propTypes = {
  classes: PropTypes.object.isRequired,
  equipId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
};

EquipmentStatusPasswordModal.defaultProps = {};

export default withStyles(styles)(EquipmentStatusPasswordModal);
